import {useProject} from "../../../providers/ClientProjectProvider";
import React, {useRef, useState} from "react";
import Form, {FormInputComponent} from "../../../components/form/Form";
import {InputNumber, Select} from "antd";
import {useProjectScope} from "./ProjectScopeProvider";
import SpinLoader from "../../../components/SpinLoader";
import {useMount} from "react-use";
import ColorTag from "../../../components/ColorTag";

const ProjectActivityForm = ({onChange,...props}) => {

    const {project} = useProject();

    const options = TB.reduce(project.disciplines, (result, value, key) => {
        result.push({
            value: value.id,
            label: value.name
        })

        return result
    }, []);

    const {
        scope,
        getRecordKey,
        editingKey,
        isDisabled
    } = useProjectScope();

    const formRef = useRef(null);
    const firstRoleRef = useRef(null);
    let disciplines = TB.orderBy(props.record?.disciplines || [], 'display_index', 'asc');
    useMount(() => {
        setTimeout(() => {
            // console.log('cslkdcms', formRef);
            // window.formRef = formRef;
            if (firstRoleRef?.current && disciplines?.length) {
                window.firstRoleRef = firstRoleRef
                firstRoleRef.current.select();
            }
        }, 100)
    })

    // console.log('Deliverable', TB.get(scopePhases, TB.split(editingKey, '.activities')[0]))
    // console.log('Phase', TB.get(scopePhases, TB.split(editingKey, '.deliverables')[0]))
    const [isSelectOpen, setIsSelectOpen] = useState(false);

    return (
        <SpinLoader isLoading={isDisabled}>
            <Form
                ref={formRef}
                model={scope}
                onChange={(model) => {
                    console.log('ProjectActivityFormChange', model)
                    return onChange(model);
                }}
                onSubmit={null}
                submitButton={false}
                minimal
                background="transparent"
                fields={[]}
                isDisabled={isDisabled}
            >
                <div className="flex flex-col items-stretch">

                    <div className="flex flex-row items-start gap-4">
                        <div className="basis-3/4">
                            <FormInputComponent
                                fieldName={`${props.recordKey}.description`}
                                value={props.record?.description || ''}
                                required={false}
                                label="Activity Description:"
                                type="editor"
                                tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                            />
                        </div>
                    </div>

                    <div className="flex flex-row items-start gap-4">
                        <div className="basis-3/4">
                            <FormInputComponent
                                fieldName={`${props.recordKey}.disciplines`}
                                value={TB.map(props.record?.disciplines || [], record => ({
                                    ...record,
                                    value: record.id,
                                    label: record.name
                                }))}
                                className="activity-role-select"
                                disabled={false}
                                required={false}
                                label={"Required Roles:"}
                                type="antd-input"
                            >

                                <Select
                                    mode="multiple"
                                    showArrow
                                    filterOption={(inputValue, option) => {
                                        return String(option.label).toLowerCase().includes(String(inputValue)
                                            .toLowerCase())
                                    }}
                                    tagRender={({id, label}) => (
                                        <ColorTag
                                            key={`${props.recordKey}-${id}`}
                                            label={label}
                                            closable={false}/>
                                    )}
                                    defaultValue={TB.map(props.record?.disciplines || [], record => ({
                                        ...record,
                                        value: record.id,
                                        label: record.name
                                    }))}
                                    open={isSelectOpen}
                                    onDropdownVisibleChange={(visible) => setIsSelectOpen(visible)}
                                    onSelect={() => setIsSelectOpen(false)}
                                    onDeselect={() => setIsSelectOpen(false)}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                    options={options || []}
                                />
                            </FormInputComponent>

                        </div>
                    </div>

                    <div className="flex flex-col items-stretch discipline-form-table">

                        <label className="col-form-label">
                            Estimated Hours by Role
                        </label>
                        <div className="mt-4 border-b border-b-black">
                            <div className="flex flex-row items-center gap-4 justify-between">
                                <p className="font-medium text-sm basis-1/4 flex-grow">
                                    Name
                                </p>

                                <p className="font-medium text-sm flex-1 text-right">
                                    Market Rate
                                </p>
                                <p className="font-medium text-sm flex-1 text-right">
                                    Hours
                                </p>
                                <p className="font-medium text-sm flex-1 text-right">
                                    Est. Cost
                                </p>
                            </div>

                        </div>
                        {TB.map(disciplines, (discipline, dIndex) => (
                            <div key={discipline.id} className="py-3 border-b border-b-gray-50">

                                <div className="flex flex-row items-center gap-4 justify-between">
                                    <p className="basis-1/4 flex-grow">
                                        {discipline.name}
                                    </p>


                                    <p className={TB.mapClass("text-sm flex-1 text-right", {"line-through opacity-60 text-danger": !discipline.is_active})}>
                                        {TB.formatCurrency(discipline.market_rate, false)}/hr
                                    </p>


                                    <div className="text-sm flex-1 text-right">
                                        <FormInputComponent
                                            fieldName={`${props.recordKey}.disciplines[${dIndex}].total_hours`}
                                            value={discipline.total_hours || ''}
                                            disabled={isDisabled}
                                            required={false}
                                            placeholder="0"
                                            label={false}
                                            type="antd-input">

                                            <InputNumber
                                                ref={dIndex === 0 ? firstRoleRef : undefined}
                                                controls={false} size="small"
                                                defaultValue={discipline.total_hours || undefined}/>

                                        </FormInputComponent>
                                    </div>

                                    <p className={TB.mapClass("text-sm flex-1 text-right", {"line-through opacity-60 text-danger": !discipline.is_active})}>
                                        {TB.formatCurrency(discipline.estimated_cost, false)}
                                    </p>

                                </div>

                            </div>
                        ))}
                        <div className="mb-4 border-t border-t-black py-3">
                            <div className="flex flex-row items-center gap-4 justify-between">
                                <p className="font-semibold text-primary text-sm basis-1/4 flex-grow">

                                </p>

                                <p className="font-medium text-sm flex-1 text-right">
                                    Total
                                </p>
                                <p className="font-semibold text-primary text-sm flex-1 text-right">
                                    {`${props.record.total_hours} hrs`}
                                </p>
                                <p className="font-semibold text-primary text-sm flex-1 text-right">
                                    {TB.formatCurrency(props.record.estimated_cost, false)}
                                </p>
                            </div>

                        </div>
                    </div>

                </div>
            </Form>
        </SpinLoader>
    )
}

export default ProjectActivityForm